import { RouteConfig } from 'vue-router';

const ROUTES_PATH: string = './routes/';

const ROUTE_FILENAMES: Array<string> = [
	'auth/login',
	'auth/login-help',
	'auth/how-register',
	'home/home',
	'home/company-accounts',
	'home/create-sum-payment',
	'home/status-payment-drafts',
	'home/status-payment-inbox',
	'home/status-payment-revision',
	'home/card-replenishment',
	'services',
	'transactions-history',
	'register',
	'munis',
	'plans',
	'exchange-rates',
	'settings',
	'electronic-commerce',
	'employees',
	'support',
	'counterparties',
	'payroll',
	'ui-lib',
	'payment-requirements'
];

export default ROUTE_FILENAMES.map(i => require(ROUTES_PATH + i + '.ts').default) as Array<RouteConfig>;
